function a(t, e) {
  return Object.keys(e).forEach((r) => {
    t[r] = e[r];
  }), t;
}
export {
  a as default
};
//# sourceMappingURL=nestedComponent.js.map
